//react
import { useUser } from "../../Providers/User";

//form
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

//components
import Input from "../Input";
import { Container } from "./styles";
import Button from "../Button";
import { IUserADM, IUserColab } from "../../Interfaces";
import { userID } from "../../Services/api";
interface IUserFormProps {
  user?: IUserColab | IUserADM;
}

export const UserForm = ({ user }: IUserFormProps) => {
  const { registerUser, editColab } = useUser();

  const formSchema = yup.object().shape({
    name: yup
      .string()
      .required("Nome obrigatório")
      .max(15, "Máximo 15 caractéres"),
    email: yup.string().required("E-mail obrigatório").email("E-mail inválido"),
    password: yup
      .string()
      .required("Senha obrigatória")
      .min(8, "Deve possuir no mínimo 8 caracteres")
      .matches(/\d/, "Deve possuir pelo menos um dígito")
      .matches(/[a-z]/, "Deve possuir pelo menos um caractere minusculo")
      .matches(/[A-Z]/, "Deve possuir pelo menos um caractere maiúsculo")
      .matches(/[!@#$%^&*]/, "Deve possuir pelo menos um caractere especial"),
    confirmPassword: yup
      .string()
      .required("Deve confirmar a senha")
      .oneOf([yup.ref("password")], "Senha diferente"),
  });

  interface IInputs {
    name: string;
    email: string;
    password: "";
    confirmPassword: "";
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IInputs>({
    defaultValues: {
      name: user?.name || "",
      email: user?.email || "",
      password: "",
      confirmPassword: "",
    },
    resolver: yupResolver(formSchema),
  });

  interface ISubmitUserData {
    name: string;
    email: string;
    password: string;
  }

  const onSubmit = (data: ISubmitUserData): void => {
    const { name, email, password } = data;
    if (user === undefined) {
      registerUser({
        name: name,
        email: email,
        password: password,
        isAdm: false,
      });
    } else {
      const { isAdm } = user;

      editColab({
        name: name,
        email: email,
        password: password,
        id: user?.id,
        isAdm: isAdm,
        idAdm: userID,
      });
    }
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Input
          className="nameInput"
          label="Name"
          name="name"
          register={register}
          placeholder="Nome de usuário"
        />
        {!!errors.name && <p className="error">{errors.name.message}</p>}
        <Input
          className="emailInput"
          label="E-mail"
          name="email"
          register={register}
          placeholder="E-mail"
        />
        {!!errors.email && <p className="error">{errors.email.message}</p>}
        <Input
          className="passwordInput"
          label="Senha"
          name="password"
          register={register}
          placeholder="Senha"
          type="password"
        />
        {!!errors.password && (
          <p className="error">{errors.password.message}</p>
        )}
        <Input
          className="confirmPasswordInput"
          label="Corfirmar senha"
          name="confirmPassword"
          register={register}
          placeholder="Confirme"
          type="password"
        />
        {!!errors.confirmPassword && (
          <p className="error">{errors.confirmPassword.message}</p>
        )}
        {user !== undefined ? (
          <Button className="submit">Editar</Button>
        ) : (
          <Button className="submit">Criar</Button>
        )}
      </form>
    </Container>
  );
};
